import { createFileRoute } from '@tanstack/react-router';
import { OfferDetailPage } from '../../features/rfq';

export const Route = createFileRoute('/portal/offers/$id')({ component: OfferDetailPage });
